import { motion } from 'motion/react';
import { OrgMemberAvatarWithCard } from './OrgMemberAvatar';

/** Matches card-mdl background so stacked avatars separate cleanly on dark surfaces. */
const AVATAR_STACK_RING = 'rounded-full ring-2 ring-dark-surface';

const overflowSizeClasses = {
  xs: 'h-6 w-6 text-[10px]',
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-xs',
  lg: 'h-12 w-12 text-sm',
};

export function AvatarGroup({ members = [], max = 4, size = 'sm' }: any) {
  const visible = members.slice(0, max);
  const overflow = members.length - max;
  const overflowSize = overflowSizeClasses[size] || overflowSizeClasses.sm;

  return (
    <div className="flex -space-x-2">
      {visible.map((member, i) => (
        <motion.div
          key={member.id || member.username || i}
          initial={{ opacity: 0, x: -8 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: i * 0.05, type: 'spring', stiffness: 400, damping: 30 }}
          className={`relative ${AVATAR_STACK_RING}`}
          style={{ zIndex: visible.length - i }}
        >
          <OrgMemberAvatarWithCard member={member} size={size} />
        </motion.div>
      ))}
      {overflow > 0 ? (
        <motion.div
          initial={{ opacity: 0, x: -8 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: visible.length * 0.05, type: 'spring', stiffness: 400, damping: 30 }}
          className={`relative inline-flex items-center justify-center rounded-full border-2 border-dark-border bg-dark-elevated font-medium text-slate-300 ${AVATAR_STACK_RING} ${overflowSize}`}
          style={{ zIndex: 0 }}
        >
          +{overflow}
        </motion.div>
      ) : null}
    </div>
  );
}

export default AvatarGroup;
